import { LmpPreviewArticleQuery } from '../types';
import { IArticleTemplatePreviewElements, venueRowPrefix, venueTextPrefix } from '../templates/article-templates';
import { getTimezoneTime, getMatchDateTimeString } from '../../../utils/date';

export const transformArticleElements = (articleData: LmpPreviewArticleQuery): IArticleTemplatePreviewElements => {
  const article = articleData.data.getLmpPreviewText;
  const { home, away, competition, calendar, ranking, results, venue, matchStartDateTime, competitionName } = article;
  const venueRowP = venue ? venueRowPrefix : '';
  const venueTextP = venue ? venueTextPrefix : '';
  const hoursStart = matchStartDateTime ? getTimezoneTime(new Date(matchStartDateTime)) : '';
  const matchDateTimesString = matchStartDateTime ? getMatchDateTimeString(new Date(matchStartDateTime)) : '';

  return {
    teamHome: {
      text: home!.name!,
    },
    teamAway: {
      text: away!.name!,
    },
    teamHomeWithLink: {
      text: home!.name!,
      link: home!.link!,
    },
    teamAwayWithLink: {
      text: away!.name!,
      link: away!.link!,
    },
    coachTeamHome: {
      text: home!.coach!,
    },
    coachTeamAway: {
      text: away!.coach!,
    },
    competition: {
      text: competitionName!,
    },
    venue: {
      text: venue || '',
    },
    venueRowPrefix: {
      text: venueRowP,
    },
    venueTextPrefix: {
      text: venueTextP,
    },
    homeNewsCompetitionLink: {
      text: competition!.text!,
      link: competition!.link!,
    },
    calendarLink: {
      text: calendar!.text!,
      link: calendar!.link!,
    },
    rankingLink: {
      text: ranking!.text!,
      link: ranking!.link!,
    },
    resultsLink: {
      text: results!.text!,
      link: results!.link!,
    },
    dayMonthYear: {
      text: matchDateTimesString,
    },
    hours: {
      text: hoursStart,
    },
  };
};
